<template>
    <div class="tablePmm">
        <table class="table pmmTable" v-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'ACT'">
            <thead>
                <tr>
                    <th>{{$t('tradeId')}}</th>
                    <th>{{$t('AccountID')}}</th>
                    <th>{{$t('symbol')}}</th>
                    <th>{{$t('type')}}</th>
                    <th>{{$t('quantity')}}</th>
                    <th>{{$t('price')}}</th>
                    <th>{{$t('openTime')}}</th>
                </tr>
            </thead>
            <tbody v-if="accountDetails != '' && 'open_trades' in accountDetails &&  Object.keys(accountDetails.open_trades).length >0">
                <tr v-for="list in accountDetails.open_trades">
                    <td>{{list.TradeID}}</td>
                    <td>{{list.AccountID}}</td>
                    <td>{{list.Symbol}} </td>
                    <td v-if="list.Side == 1">{{$t('buy')}}</td>
                    <td v-if="list.Side == 0">{{$t('sell')}}</td>
                    <td>{{list.Quantity}}</td>
                    <td>{{list.Price}}</td>
                    <td>{{timeFuncDate(list.OpenTime)}}</td>
                </tr>
            </tbody>
			<tbody v-else>
				<tr >
					<td class="noRecordFound"  colspan="7"> 
						<img src="../../../../../static/fxView/images/search.svg" alt="no record found">
						<p>{{$t('thereIsNoRecord')}}</p>
					</td>
				</tr>
			</tbody>
            <!--<loader-component :pageloader_value="'false'" :type="'table'" :colspan="col_span" :list="accountDetails" v-else></loader-component>-->
        </table>
        
        <table class="table pmmTable" v-else-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'MT4'">
            <thead>
                <tr>

                    <!-- Order id = order; 
                    Login = login; 
                    Symbol = symbol; 
                    Type= cmd; 
                    Volume= volume; 
                    Open Time = open_time;
                    Open Price= open_price; 
                    SL= sl;
                    TP = tp; 
                    PNL = profit; 
                    Com=commission; 
                    Comment=comment -->
                    <th>{{$t('login')}}</th>
                    <th>{{$t('order')}}</th>
                    <th>{{$t('symbol')}}</th>
                    <th>{{$t('type')}}</th>
                    <th>{{$t('volume')}}</th>
                    <th>{{$t('openTime')}}</th>
                    <th>{{$t('openPrice')}}</th>
                    <th>{{$t('SL')}}</th>
                    <th>{{$t('TP')}}</th>
                    <th>{{$t('commision')}}</th>
                    <th>{{$t('PNL')}}</th>
                    <th>{{$t('comment')}}</th>
				</tr>
            </thead>
            <tbody v-if="accountDetails != '' && 'open_trades' in accountDetails && Object.keys(accountDetails.open_trades).length >0 && accountDetails.open_trades.csv_array.length > 0">
                <tr v-for="list in accountDetails.open_trades.csv_array" >
                    <!--
                    Mt4 
                    0-order; 
                    1-login; 
                    2-symbol; 
                    3-cmd; 
                    4-volume; 
                    5-open_time;
                    6-open_price; 
                    7-sl; 
                    8- tp; 
                    9- profit; 
                    10 commission; 
                    11 comment -->
                    <td>{{list[1]}}</td>
                    <td>{{list[0]}}</td>
                    <td>{{decodeURIComponent(list[2])}}</td>
                    <td>{{list[3].toUpperCase()}}</td>
                    <td>{{list[4]/100}}</td>
                    <td>{{timeFunc(list[5])}}</td>
                    <td>{{list[6]}}</td>
                    <td>{{list[7]}}</td>
                    <td>{{list[8]}}</td>
                    <td>{{list[10]}}</td>
                    <td>{{list[9]}}</td>
                    <td>{{list[11]}}</td>
                </tr>
            </tbody>
			<tbody v-else>
				<tr>
					<td class="noRecordFound"  colspan="13"> 
						<img src="../../../../../static/fxView/images/search.svg" alt="no record found">
						<p>{{$t('thereIsNoRecord')}}</p>
					</td>
				</tr>
			</tbody>
        </table>
		
		<table class="table pmmTable" v-else-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'MT5'">
            <thead>
                <tr>
                    <th>{{$t('login')}}</th>
                    <th>{{$t('order')}}</th>
                    
                    <th>{{$t('symbol')}}</th>
                    <th>{{$t('type')}}</th>
                    <th>{{$t('volume')}}</th>
                    <th>{{$t('openTime')}}</th>
                    <th>{{$t('openPrice')}}</th>
                    <th>{{$t('SL')}}</th>
                    <th>{{$t('TP')}}</th>
                    
                    <th>{{$t('commision')}}</th>
                    <th>{{$t('PNL')}}</th>
                </tr>
            </thead>
            <tbody v-if="accountDetails != '' && 'open_trades' in accountDetails && Object.keys(accountDetails.open_trades).length >0 && accountDetails.open_trades.csv_array.length > 0">
                <tr v-for="list in accountDetails.open_trades.csv_array" >

                    <!--  Mt5 output order; 
                        0 position; 
                        1 login; 
                        2 symbol; 
                        3 action; 
                        4 volume;
                        5 open_time; 
                        6 open_price; 
                        7 sl; 
                        8 tp; 
                        9 profit; 
                        10 comment 

                        ;login;symbol;action;volume;open_time;open_price;sl;tp;profit;comment
                    -->
                     <td >{{list[1]}}</td>
                    <td>{{list[0]}}</td>
                   
                    <td>{{decodeURIComponent(list[2])}}</td>
                    <td v-if="list[3] == 0">{{$t('buy')}}</td>
                    <td v-if="list[3] == 1">{{$t('sell')}}</td>
                    <td>{{list[4]}}</td>
                    <td>{{timeFunc(list[5])}}</td>
                    <td>{{list[6]}}</td>
                    <td>{{list[7]}}</td>
                    <td>{{list[8]}}</td>
                    <td>{{list[10]}}</td>
                    <td>{{list[9]}}</td>
                </tr>
            </tbody>
			<tbody v-else>
				<tr>
					<td class="noRecordFound"  colspan="11"> 
						<img src="../../../../../static/fxView/images/search.svg" alt="no record found">
						<p>{{$t('thereIsNoRecord')}}</p>
					</td>
				</tr>
			</tbody>
        </table>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const }  from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	import moment from 'moment'
    export default {
        name: 'Dashboard',
        mixins: [fxViewMixins],
		props:['pageName'],
        data() {
            return {col_span : 7 ,col_span1 : 13}
        },
		methods:{
			timeFunc(getData){
				return moment.unix(getData).format("DD-MM-YYYY, h:mm:ss");
			},
            timeFuncDate(getData){
                return moment(getData).format("DD-MM-YYYY, h:mm:ss");
            },
		}
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/tradingAccounts/open_trades_listing.vue